import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dynamicFormTemplate: {},
  dynamicStore: null,
};

const dynamicFormReducer = createSlice({
  name: "dynamicFormReducer",
  initialState: initialState,
  reducers: {
    setFormTemplate: (state, { payload }) => {
      state.dynamicFormTemplate = payload;
    },
    setDynamicStore: (state, { payload }) => {
      state.dynamicStore = { ...state.dynamicStore, [payload.key]: payload[payload.key] };
    },
  },
});

export default dynamicFormReducer;
